<template>
  <md-list :md-expand-single="true" v-if="menu && menu.length">
    <md-list-item @click="$emit('toggle')">
      <md-icon v-if="!visible">menu</md-icon>
      <md-icon v-if="visible">keyboard_arrow_left</md-icon>
      <span class="md-list-item-text">{{ $t('menu.hide') }}</span>
      <md-tooltip md-direction="right" v-show="!visible">{{ $t('menu.expand') }}</md-tooltip>
    </md-list-item>
    <s1vm-menu-item v-for="item in menu" :key="item.name" :menu="item" :visible.sync="visible"></s1vm-menu-item>
  </md-list>
</template>
<script>
export default {
  props: {
    visible: Boolean
  },
  methods: {
  },
  computed: {
    menu() {
      return this.$store.state.app && this.$store.state.app.menu;
    }
  }
}
</script>
